import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ListingCard from './ListingCard.js';
import LoadingCards from '../LoadingCards.js';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '1rem 0',
  },
});

const ListingsCardList = ({isLoading, data, nullMessage}) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <LoadingCards />
    );
  }

  if (data.length === 0) {
    return (
      <div className={classes.root}>
        <Alert severity="info">{nullMessage}</Alert>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {data.map((item, i) =>
        <ListingCard
          key={i}
          data={item}
        />
      )}
    </div>
  );
};

ListingsCardList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  nullMessage: PropTypes.string.isRequired,
};

export default ListingsCardList;
